import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import gql from 'graphql-tag'

export const DOC = gql`
  mutation PutZoneData(
    $tenantId: ID!
    $zoneId: ID!
    $insertion: DataInsertion!
  ) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        putData(insertion: $insertion)
      }
    }
  }
`

const TRANSFORMER = graphql.transformers.OUT.always(undefined)

export const executor = graphql.createExecutor<
  graphql.schema.PutZoneDataMutation,
  undefined,
  graphql.schema.PutZoneDataMutationVariables
>({
  query: DOC,
  transformer: TRANSFORMER,
})
